import React from 'react';
import { CircularProgress, styled } from '@nextiva/next-ui-components';

export const StyledLoadingSpinner = styled(CircularProgress)`
  margin-right: 8px;
`;
export const StyledContainer = styled('div')`
  position: absolute;
  z-index: -1;
  margin: 0px 100px 100px 0px;
`;

export const GradientLoadingSpinner = () => (
  <>
    <StyledContainer>
      <svg>
        <defs>
          <linearGradient
            id="gradientSpinner"
            x1="0%"
            y1="0%"
            x2="0%"
            y2="100%"
          >
            <stop offset="0%" stopColor="rgba(245,250,255, 1)" />
            <stop offset="100%" stopColor="rgba(245,250,255, 0.25)" />
          </linearGradient>
        </defs>
      </svg>
    </StyledContainer>
    <StyledLoadingSpinner
      size={16}
      aria-label="Loading"
      data-testid="PlatformAdminUI-PurchaseLicenseModal-PayButton-LoadingSpinner"
      sx={{
        'svg circle': { stroke: 'url(#gradientSpinner)' },
      }}
    />
  </>
);
